import React from "react"
import PropTypes from "prop-types"
import { Icon } from "ui/Icon"
import styles from "./AddOnPhoto.module.css"

// Renders an add-on thumbnail. Falls back to a generic image icon when `src` is missing.
const AddOnPhoto = ({ src, alt, size, iconSize, className }) => {
  const sizeVar = { "--addon-photo-size": `${size}px` }
  if (src) {
    return <img src={src} alt={alt} style={sizeVar} className={`${styles.thumbnail} ${className}`} />
  }
  return (
    <div style={sizeVar} className={`${styles.placeholder} ${className}`}>
      <Icon type="feather" name="Image" width={iconSize} height={iconSize} />
    </div>
  )
}

AddOnPhoto.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.number,
  iconSize: PropTypes.number,
  className: PropTypes.string
}

AddOnPhoto.defaultProps = {
  src: null,
  alt: "",
  size: 48,
  iconSize: 20,
  className: ""
}

export default AddOnPhoto
